<template>
  <el-dialog id="drop" :title="titles" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :width="w">
    <slot name="dialog-main"></slot>
    <div slot="footer" class="dialog-footer" v-if="showCls||showOk">
      <el-button v-if="showCls" @click="dialogFormVisible = false">取 消</el-button>
      <el-button v-if="showOk" type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default{
    props: ['opts', 'title','width','show-close','show-confirm'],
    name: 'form-dialog',
    data(){
      return {
        fn: this.opts,
        dialogFormVisible: false,
        titles: this.title || '内容',
        w:this.width,
        showCls:this.showClose === false?false:true,
        showOk:this.showConfirm === false?false:true
      }
    },
    methods: {
      show(){
        this.dialogFormVisible = true
      },
      hide(){
        this.dialogFormVisible = false
      },
      confirm(){
        this.dialogFormVisible = false
        this.$emit('on-confirm')
      },
      isShow(){
        return  this.dialogFormVisible;
      }
    },
    watch:{
      title(val){
          this.titles = val
      },
      showClose(val){
        this.showCls = val === false?false:true
      },
      showConfirm(val){
        this.showOk = val === false?false:true
      }
    }

  }
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/components/FormDialog.vue